import React, { Component } from 'react'
import ElasticReindexStore from './ElasticReindex.store'
import { observer } from 'mobx-react'
import map from 'lodash/map'
import moment from 'moment'
import './ElasticReindex.sass'

class ElasticReindex extends Component {
  constructor (props) {
    super(props)
    this.store = new ElasticReindexStore()
    this.store.getState()
    this.interval = setInterval(() => this.store.getState(), 2500)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  renderState = ({ progress, total, error, finished, jobId, scheduledAt }) => {
    if (progress && jobId) {
      return (
        <div className='elasticIndexStyle--progress-container'>
          <div className='elasticIndexStyle--progress-container-text'>
            {progress} / {total}
          </div>
          <div
            className='elasticIndexStyle--progress-bar'
            style={{ width: (progress / total) * 300 }}
          >
            <div className='elasticIndexStyle--progress-bar-text'>
              {progress} / {total}
            </div>
          </div>
        </div>
      )
    } else if (error) {
      return <strong title={JSON.stringify(error, null, 2)}>Error</strong>
    } else if (jobId) {
      return <strong>Queued {moment(scheduledAt).fromNow()}</strong>
    } else if (finished) {
      return (
        <span>
          Finished {finished && moment(finished).format('DD/MM/YYYY HH:mm')}
        </span>
      )
    }
  }

  render () {
    return (
      <div style={{ padding: 15 }}>
        {!this.store.state && <div>Loading</div>}
        <table className='table-wrapper--nested' style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Index name</th>
              <th>Kibana Log</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {map(this.store.state, (state, key) => (
              <tr className='elasticIndeStyle'>
                <td>{key}</td>
                <td style={{ width: 320 }}>
                  {state.jobId && state.searchService && (
                    <a
                      target='_blank'
                      href={`https://events.atheneum-app.com/_plugin/kibana/app/kibana#/discover/?_g=()&_a=(columns:!(subject,logging_description),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'6b0bed80-fb75-11e9-9eb9-1f1d1efb2e94',key:logging_id,negate:!f,params:(query:'9e9acd76-e09c-4cb6-a50b-fcb5c3c21968'),type:phrase,value:'9e9acd76-e09c-4cb6-a50b-fcb5c3c21968'),query:(match:(logging_id:(query:'${
                        state.jobId
                      }',type:phrase))))),index:'6b0bed80-fb75-11e9-9eb9-1f1d1efb2e94',interval:auto,query:(language:kuery,query:''),sort:!(timestamp,desc))`}
                    >
                      {state.jobId}
                    </a>
                  )}
                </td>
                <td style={{ width: 320 }}>
                  <div>{this.renderState(state)}</div>
                </td>

                <td>
                  {state.jobId ? (
                    <a
                      href='#'
                      onClick={e => {
                        e.preventDefault()
                        this.store.cancel(key)
                        return false
                      }}
                    >
                      cancel
                    </a>
                  ) : (
                    <>
                      <a
                        href='#'
                        onClick={e => {
                          e.preventDefault()
                          this.store.reindex(key)
                          return false
                        }}
                      >
                        reindex
                      </a>{' '}
                      <a
                        href='#'
                        onClick={async e => {
                          e.preventDefault()
                          await this.store.dropIndex(key)
                          alert('Index recreated using latest index mapping')
                          return false
                        }}
                      >
                        drop index
                      </a>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default observer(ElasticReindex)
